import { useLayoutEffect, useRef, useState } from "react";
import type { WorkArea } from "./windowGeometry";

function fallbackArea(): WorkArea {
  return { width: window.innerWidth, height: Math.max(1, window.innerHeight - (window.innerWidth <= 720 ? 54 : 58)) };
}

export function useDesktopWorkArea() {
  const stageRef = useRef<HTMLElement>(null);
  const [workArea, setWorkArea] = useState(fallbackArea);

  useLayoutEffect(() => {
    const stage = stageRef.current;
    const measure = () => {
      const bounds = stage?.getBoundingClientRect();
      const next = bounds && bounds.width > 0 && bounds.height > 0
        ? { width: Math.floor(bounds.width), height: Math.floor(bounds.height) }
        : fallbackArea();
      setWorkArea((current) => current.width === next.width && current.height === next.height ? current : next);
    };
    measure();
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(measure);
    if (stage) observer?.observe(stage);
    window.addEventListener("resize", measure);
    return () => { observer?.disconnect(); window.removeEventListener("resize", measure); };
  }, []);

  return { stageRef, workArea };
}
